<ng-container *ngIf="formControl; then formInput; else simpleInput"></ng-container>

<ng-template #formInput>
  <mat-form-field>
    <mat-label class="label">{{ label }}</mat-label>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <input matInput
           currencyMask
           [formControl]="formControl"
           [placeholder]="placeholder"
           [options]="options"
           [required]="required ? '' : null"
           [readonly]="readonly"
           (input)="onChange($event)"
           (keydown.enter)="onEnterPress()"
    />
  </mat-form-field>
  <app-form-error-list *ngIf="showValidations"
                       [errorMap]="formControl.errors">
  </app-form-error-list>
</ng-template>

<ng-template #simpleInput>
  <mat-form-field>
    <mat-label class="label">{{ label }}</mat-label>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <input matInput
           currencyMask
           [value]="value"
           [placeholder]="placeholder"
           [options]="options"
           [required]="required ? '' : null"
           (input)="onChange($event)"
           (keydown.enter)="onEnterPress()"
    />
  </mat-form-field>
</ng-template>
